import { type FC } from 'react';

import {
  type PaidSpecContractType,
  type SpecContractStatusType,
  type SpecContractType,
} from '@/common/types/contract';
import { AboutSpecContract } from '@/components/Contract/AboutSpecContract/AboutSpecContract';
import { GrandContractDetail } from '@/components/Contract/Grand/GrandContractDetail/GrandContractDetail';

import { SpecContractWrapper } from '../common/SpecContractWrapper/SpecContractWrapper';

interface GoldenContractModal {
  status: SpecContractStatusType;
  kind: SpecContractType | PaidSpecContractType;
}

const GoldenContractModal: FC<GoldenContractModal> = ({ status, kind }) => {
  return (
    <SpecContractWrapper kind={kind}>
      {status === 'forViewing' ? (
        <AboutSpecContract kind={kind} />
      ) : (
        <GrandContractDetail status={status} kind={kind} />
      )}
    </SpecContractWrapper>
  );
};

export { GoldenContractModal };
